import client from './client';
import { Therapeutic, TherapeuticCreate, TherapeuticUpdate, TherapeuticListItem, TherapeuticBatchEnrichRequest } from '../types/therapeutic';

export const searchTherapeutics = async (query: string, limit: number = 20): Promise<TherapeuticListItem[]> => {
  const response = await client.get('/api/v1/therapeutics/search', {
    params: { q: query, limit },
  });
  return response.data.results;
};

export const getTherapeutic = async (id: string): Promise<Therapeutic> => {
  const response = await client.get(`/api/v1/therapeutics/${id}`);
  return response.data;
};

export const createTherapeutic = async (data: TherapeuticCreate): Promise<Therapeutic> => {
  const response = await client.post('/api/v1/therapeutics/', data);
  return response.data;
};

export const updateTherapeutic = async (id: string, data: TherapeuticUpdate): Promise<Therapeutic> => {
  const response = await client.put(`/api/v1/therapeutics/${id}`, data);
  return response.data;
};

export const deleteTherapeutic = async (id: string): Promise<void> => {
  await client.delete(`/api/v1/therapeutics/${id}`);
};

export const batchEnrichTherapeutics = async (data: TherapeuticBatchEnrichRequest): Promise<any> => {
  const response = await client.post('/api/v1/therapeutics/batch-enrich', data);
  return response.data;
};

export const enrichTherapeutic = async (
  id: string
): Promise<{ therapeutic?: Therapeutic; comparison?: Record<string, any>; error?: string }> => {
  const response = await client.post(`/api/v1/therapeutics/${id}/enrich`);
  return response.data;
};

export const findClinicalTrials = async (
  id: string
): Promise<any> => {
  const response = await client.post(`/api/v1/therapeutics/${id}/find-trials`);
  return response.data;
};
